import React, { Component } from 'react'
import Input from '@Form/Input'
import Checkbox from '@Form/Checkbox'
import Select from '@Form/Select'

const defaultQuadrantNames = {
    bottomLeft: '',
    bottomRight: '',
    topLeft: '',
    topRight: '',
}

class Settings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isMatrix: !!props.kpi.settings.quadrantNames,
        }
    }

    changeSetting = ({ value, name }) => {
        const { kpi } = this.props
        const { settings } = kpi

        settings[name] = value
    }

    render() {
        const { kpi } = this.props
        const { settings } = kpi
        const { isMatrix } = this.state
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                    padding: '10px',
                }}
            >
                <h4>Settings</h4>
                <Checkbox
                    name="allowQuadrantAnalysis"
                    label="Allow Quadrant Analysis"
                    defaultChecked={settings.allowQuadrantAnalysis}
                    className="exploriNativeCheckbox"
                    onBlur={this.changeSetting}
                />
                <Input
                    name="min"
                    label="Min"
                    isNumeric
                    defaultValue={settings.min}
                    onBlur={this.changeSetting}
                />
                <Input
                    name="max"
                    label="Max"
                    isNumeric
                    defaultValue={settings.max}
                    onBlur={this.changeSetting}
                />
                <Input
                    name="decimals"
                    label="Decimals"
                    isNumeric
                    isMandatory
                    defaultValue={settings.decimals}
                    onBlur={this.changeSetting}
                />
                <Select
                    name="format"
                    label="Format"
                    options={[
                        { label: 'Numeric', value: 'numeric' },
                        { label: 'Currency', value: 'currency' },
                        { label: '%', value: '%' },
                    ]}
                    defaultValue={settings.format}
                    onBlur={this.changeSetting}
                />
                <Checkbox
                    name="matrixKpi"
                    label="Is Matrix KPI"
                    defaultChecked={!!settings.quadrantNames}
                    className="exploriNativeCheckbox"
                    onBlur={({ value }) => {
                        this.changeSetting({ value: value ? defaultQuadrantNames : undefined, name: 'quadrantNames' })
                        this.setState({ isMatrix: value })
                    }}
                />
                {isMatrix
                    ? (
                        <>
                            <Input
                                name="bottomLeft"
                                label="Bottom Left"
                                isMandatory
                                defaultValue={settings.quadrantNames.bottomLeft}
                                onBlur={({ value }) => (
                                    this.changeSetting({
                                        value: { ...settings.quadrantNames, bottomLeft: value },
                                        name: 'quadrantNames',
                                    })
                                )}
                            />
                            <Input
                                name="bottomRight"
                                label="Bottom Right"
                                isMandatory
                                defaultValue={settings.quadrantNames.bottomRight}
                                onBlur={({ value }) => (
                                    this.changeSetting({
                                        value: { ...settings.quadrantNames, bottomRight: value },
                                        name: 'quadrantNames',
                                    })
                                )}
                            />
                            <Input
                                name="topLeft"
                                label="Top Left"
                                isMandatory
                                defaultValue={settings.quadrantNames.topLeft}
                                onBlur={({ value }) => (
                                    this.changeSetting({
                                        value: { ...settings.quadrantNames, topLeft: value },
                                        name: 'quadrantNames',
                                    })
                                )}
                            />
                            <Input
                                name="topRight"
                                label="Top Right"
                                isMandatory
                                defaultValue={settings.quadrantNames.topRight}
                                onBlur={({ value }) => (
                                    this.changeSetting({
                                        value: { ...settings.quadrantNames, topRight: value },
                                        name: 'quadrantNames',
                                    })
                                )}
                            />
                        </>
                    ) : null}
            </div>
        )
    }
}

export default Settings
